import { CMIC_TREE_NODE_TYPES } from '../../../shared/Constants';

export const handleSortFormat = (data, activeNode) => {
	if (data.length === 0) return '';

	switch (activeNode) {
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
			return data[0].field === 'count' ? `PmdgTotalDocs:${data[0].sort}` : `${data[0].field}:${data[0].sort}`;

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT:
			return data[0].field === 'count' ? `NumDocuments:${data[0].sort}` : `${data[0].field}:${data[0].sort}`;

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
			return data[0].field === 'createdOn'
				? `ImgdIuCreateDate:${data[0].sort}`
				: `${data[0].field}:${data[0].sort}`;

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
			return data[0].field === 'createdOn'
				? `ImgrIuCreateDate:${data[0].sort}`
				: `${data[0].field}:${data[0].sort}`;

		default:
			return `${data[0].field}:${data[0].sort}`;
	}
};

export const handleOrderBy = nodeType => {
	switch (nodeType) {
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
			return 'PmscrfiCreateDate:desc';
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
			return 'DmiIuCreateDate:desc';
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
			return 'PmjDate:desc';
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
			return 'PmsmSbmtId:desc';
		default:
			return '';
	}
};

export const defaultSortModel = activeNode => {
	switch (activeNode) {
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
			return [{ field: 'PmscrfiCreateDate', sort: 'desc' }];
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
			return [{ field: 'DmiIuCreateDate', sort: 'desc' }];
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
			return [{ field: 'PmjDate', sort: 'desc' }];
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
			return [{ field: 'PmsmSbmtId', sort: 'desc' }];
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
			return [{ field: 'count', sort: 'desc' }];
		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
			return [{ field: 'PmdRevDate', sort: 'desc' }];
		// case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION:
		//   return [{field:"PmdrRevNum",sort:"desc"}]
		default:
			return [];
	}
};
